import { FeaturePageVisual } from "@/features/feature-page/feature-page-visual";
import type { ResolvedFeaturePageBlock } from "@garimpa/api/featurePages/types";

interface HeroBlockVisualProps {
  block: Extract<ResolvedFeaturePageBlock, { type: "hero" }>;
  split: boolean;
}

export function HeroBlockVisual({ block, split }: HeroBlockVisualProps) {
  if (!block.resolvedVisual) return null;

  return (
    <div
      className={
        split
          ? "mx-auto w-full max-w-xl overflow-hidden rounded-2xl border border-border bg-card shadow-2xl"
          : "mx-auto mt-10 w-full max-w-sm overflow-hidden rounded-2xl border border-border bg-card shadow-2xl"
      }
    >
      <FeaturePageVisual
        visual={block.resolvedVisual}
        priority
        sizes={
          split
            ? "(min-width: 640px) 576px, calc(100vw - 32px)"
            : "(min-width: 416px) 384px, calc(100vw - 32px)"
        }
        className="aspect-square h-full w-full object-cover"
      />
    </div>
  );
}
